module.exports = __webpack_public_path__ + "img/2.5290d0e6.jpg";